import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ViewerFragmentCommonProps } from "../ViewerFragment";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import TitledArticleCard from "@coworker/apprestructured/src/task-management/components/TitledArticleCard/TitledArticleCard";
import LoadingViewerFragment from "../LoadingViewerFragment/LoadingViewerFragment";
import {
  shouldShowField,
  VisibilityCondition,
} from "@coworker/apprestructured/src/task-management/helpers/visibilityCondition.helper";

export type TitledArticleViewerFragmentConfigProps = {
  field: string;
  title?: string;
  visibility?: VisibilityCondition;
};

type TitledArticleViewerFragmentProps = {
  configProps: TitledArticleViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledArticleViewerFragment({
  configProps,
  commonProps,
}: TitledArticleViewerFragmentProps) {
  const { field, title, visibility } = configProps;
  const { task } = commonProps;

  const taskIsLoading = isLoading(task);

  const itemNoAndType = taskIsLoading
    ? null
    : getTypedValue<ItemNoAndType>(getByPath(task, field));

  const itemNo =
    itemNoAndType && !isLoading(itemNoAndType) ? itemNoAndType.no || "" : "";

  const { data: item } = useItemInfo(itemNo);

  if (taskIsLoading) {
    return <LoadingViewerFragment />;
  }

  // Check visibility condition first to avoid unnecessary queries
  const isVisible =
    !visibility || shouldShowField(task as Record<string, any>, visibility);

  if (!isVisible) {
    return null;
  }

  if (!item || isLoading(item)) {
    return isLoading(item) ? <LoadingViewerFragment /> : null;
  }

  return <TitledArticleCard title={title} item={item} />;
}

export default TitledArticleViewerFragment;
